import styled from '@emotion/styled'
import ErrorFeedback from 'Components/ErrorFeedback'
import PageContainer from 'Components/PageContainer'
import {
  EmptyState,
  Loading,
  ToastContainer,
  Tooltip
} from 'mailup-web-components'
import Header from 'Pages/SourcesList/components/Header'
import ModalNewSource from 'Pages/SourcesList/components/ModalNewSource'
import Results from 'Pages/SourcesList/components/Results'
import { initPageCallback } from 'Pages/SourcesList/recoil/callbacks/callbacks'
import { modalNewSourceState } from 'Pages/SourcesList/recoil/state/modals'
import { pageState } from 'Pages/SourcesList/recoil/state/page'
import { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from 'recoil'

export const Container = styled.div`
  min-width: 730px;
  max-width: 1200px;
  margin: 0 auto;
`

const SourcesList = () => {
  const intl = useIntl()
  const { isEmptyState, error, severity, items, fetching, fetchingLoaded } =
    useRecoilValue(pageState)

  const setShowModal = useSetRecoilState(modalNewSourceState)
  const initPage = useRecoilCallback(initPageCallback, [])

  useEffect(() => {
    initPage()
  }, [])
  return (
    <>
      <Header />
      <ModalNewSource />
      <ToastContainer />
      <Tooltip />
      <Loading open={fetching} />
      <PageContainer>
        <ErrorFeedback error={error} severity={severity} />

        {!error && fetchingLoaded && (
          <>
            {isEmptyState ? (
              <EmptyState
                title={intl.formatMessage({
                  id: 'Load.ContentsSouces.EmptyStateTitle'
                })}
                description={intl.formatMessage({
                  id: 'Load.ContentsSouces.EmptyStateDescr'
                })}
                buttonText={intl.formatMessage({
                  id: 'Load.ContentsSouces.NewSource'
                })}
                onClickButton={() => setShowModal(true)}
              />
            ) : (
              <Results datas={items} />
            )}
          </>
        )}
      </PageContainer>
    </>
  )
}

export default SourcesList
